import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavFoldersContent } from './content/NavFoldersContent';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { useIsMounted } from '../../components/hooks/useIsMounted';
import { NavItemGroup } from '../components/item-group/NavItemGroup';

type Props = {
  isOpen: boolean;
  toggle: Function;
  cancelHover: (display: boolean, dropdown: string) => void;
  isFoldersStored: boolean;
};

export const NavFoldersDropdown: FC<Props> = ({
  isOpen,
  toggle,
  cancelHover,
  isFoldersStored,
}) => {
  const { getIsMounted } = useIsMounted();

  useEffect(() => {
    cancelHover(isOpen, 'folder');
  }, [isOpen]);

  const openDropdown = () => {
    if (getIsMounted()) {
      toggle();
      doctrineAnalytics('Nav ButtonFolderClicked');
    }
  };

  return (
    <>
      <NavItemGroup onClick={openDropdown}>
        <FormattedMessage id="folders/NavFoldersDropdown.tsx/1" />
      </NavItemGroup>
      {isOpen && <NavFoldersContent foldersStored={isFoldersStored} />}
    </>
  );
};
